import { render, staticRenderFns } from "./solutegrop.vue?vue&type=template&id=0d0a1792&scoped=true&"
import script from "./solutegrop.vue?vue&type=script&lang=js&"
export * from "./solutegrop.vue?vue&type=script&lang=js&"
import style0 from "./solutegrop.vue?vue&type=style&index=0&id=0d0a1792&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0a1792",
  null
  
)

export default component.exports